// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableContainer___DcpL3{padding:16px;background:var(--white);border:1px solid var(--gray150);margin-top:16px;flex-grow:1}\n", "",{"version":3,"sources":["webpack://./src/components/MerchantRulesTable/MerchantRulesTable.css"],"names":[],"mappings":"AAAA,wBAAA,YAAA,CAEI,uBAAA,CACA,+BAAA,CACA,eAAA,CACA,WAAA","sourcesContent":[".tableContainer {\n    padding: 16px;\n    background: var(--white);\n    border: 1px solid var(--gray150);\n    margin-top: 16px;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": "tableContainer___DcpL3"
};
export default ___CSS_LOADER_EXPORT___;
